import { useEffect } from 'react';
import './App.css';
import './index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PreRegistroLayout from './components/PreRegistroLayout';
import PrivateRoute from './components/tokens/PrivateRoute';
import SignUpPage from './components/SignUpPage';
import NotFound from "./components/NotFound";
import TramiteDirecto from "./components/TramiteDirecto";
import HistorialRentas from "./components/HistorialRentas";
import GlobalTimer from './components/GlobalTimer';

const RedirectToKeycloak = () => {
  useEffect(() => {
    const loginUrl = process.env.REACT_APP_KEYCLOAK_LOGIN_URL;
    if (loginUrl) {
      window.location.replace(loginUrl);
    }
  }, []);
  return null;
};

function App() {
  const token = localStorage.getItem('token');

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.replace('#', ''));

    const accessToken = searchParams.get('access') || hashParams.get('access');
    const refreshToken = searchParams.get('refresh') || hashParams.get('refresh');

    if (accessToken && refreshToken) {
      localStorage.setItem('token', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      // Clean URL and redirect to internal route
      window.location.replace('/preregistro');
    }
  }, []);

  return (
    <BrowserRouter>
      <GlobalTimer />
      <Routes>
        <Route
          path="/"
          element={
            localStorage.getItem('token') ? <Navigate to="/preregistro" replace /> : <RedirectToKeycloak />
          }
        />
        <Route
          path="/preregistro"
          element={
            <PrivateRoute>
              <PreRegistroLayout />
            </PrivateRoute>
          }
        />
        <Route
          path="/tramite/:nombreTramite/historial"
          element={
            <PrivateRoute>
              <HistorialRentas />
            </PrivateRoute>
          }
        />
        <Route
          path="/tramite/:nombreTramite"
          element={
            <PrivateRoute>
              <TramiteDirecto />
            </PrivateRoute>
          }
        />

        <Route path="/signup" element={<SignUpPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

